import React from 'react';
import { connect } from 'react-redux';
import { toggle } from '../Actions/Cart.action';
import { updateVAT } from '../Services/Cart.service';
import { translate } from '../Services/translation';

const HeaderRowContainer = props => {
    console.log(props);
    let includeVAT = document.getElementById('headerRow').classList.contains('includeVAT-True');
    return (
        <div className="toprow">
            <span>
                <a style={{ fontWeight: includeVAT ? 'bold' : 'normal' }} href={'#'} onClick={() => updateVAT(true).then(res => location.reload())}>{translate('incVat')}</a>
                |
                <a style={{ fontWeight: !includeVAT ? 'bold' : 'normal' }} href={'#'} onClick={() => updateVAT(false).then(res => location.reload())}>{translate('exclVat')}</a>
            </span>
            <span>{translate('headerTextAskUs')}</span>
            <span class="hideOnMobile"><a href={`tel: ${translate('callUsNumber')}`}>{translate('callUsNumber')}</a></span><span class="hideOnMobile">
                <a href={`mailto: ${translate('emailUsAddress')}`}>{translate('emailUsAddress')}</a></span></div>
    )
}

const mapStateToProps = state => {
    const { cart } = state;
    return {
        ...cart,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderRowContainer);
